import { RoleActiveTools } from '@/components/ai/RoleActiveTools';

/**
 * Teacher Tools Page
 * Uses the universal RoleActiveTools + DynamicToolRunner system.
 * Replaces the legacy 987-line TeacherTools with hardcoded tool modals.
 *
 * Teachers manage which tools are active via the separate TeacherAITools page
 * (the "AI Tools" settings page at /portal/teacher/ai-tools).
 */
export default function TeacherTools() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-6">
      <RoleActiveTools
        role="teacher"
        title="Your Tools"
        description="Launch your active AI and SmartBlock tools for lesson planning, grading, and parent communication."
        marketplacePath="/portal/teacher/ai-tools"
        trackerBasePath="/portal/teacher/tracker"
        showComingSoon={true}
      />
    </div>
  );
}
